import React from "react";
import InputField from "./../../common/form/InputField";
import { AppContext } from "../../../context/AppContext";
import { useContext } from "react";

const ContactInfo = () => {
  const { profileType } = useContext(AppContext);

  return (
    <>
      <div className="mt-5">
        <h1 className="text-md font-semibold ">CONTACT INFO</h1>
        <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div className="sm:col-span-3">
            <InputField
              type="text"
              label="Contact Email Address"
              name="ContactEmailAddress"
              required
            />
            <p className="text-sm text-red-400">
              * This email will be displayed on the website. It can be different
              from the Login email.
            </p>
          </div>
          <div className="sm:col-span-3">
            <InputField
              type="number"
              label="Contact Phone Number"
              name="ContactPhoneNumber"
              required
            />
          </div>

          {profileType === "Product" ? (
            <div className="sm:col-span-2">
              <InputField
                type="text"
                label="Website Link"
                name="WebsiteLink"
                required
              />
            </div>
          ) : (
            <div className="sm:col-span-2">
              <InputField type="text" label="Website Link" name="WebsiteLink" />
            </div>
          )}

          <div className="sm:col-span-2">
            <InputField
              type="text"
              label="Facebook URL"
              name="FacebookIconLink"
            />
          </div>
          <div className="sm:col-span-2">
            <InputField
              type="text"
              label="Instagram URL"
              name="InstagramIconLink"
            />
          </div>
          <div className="sm:col-span-2">
            <InputField type="text" label="Issuu URL" name="IssueIconLink" />
          </div>
          <div className="sm:col-span-2">
            <InputField type="text" label="X URL" name="XIconLink" />
          </div>
          <div className="sm:col-span-2">
            <InputField
              type="text"
              label="Youtube URL"
              name="YoutubeIconLink"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactInfo;
